import { Tabs } from 'react-vant'
import SurverList from '@/pages/Home/Questionnaire/components/SurverList'
import { useState } from 'react';

const Survey = () => {
  const [activeTab, setActiveTab] = useState('all');
  
  const itemList = [{
    key: 1,
    label: '全部',
    name: 'all'
  },{
    key: 2,
    label: '进行中',
    name: 'Ing'
  },{
    key: 3,
    label: '已提交',
    name: 'submited'
  }]
  const tabChange = (name: any) => {
    setActiveTab(name)
  };

  return (
    <div className='demo-tabs'>
      <Tabs active={activeTab} sticky={true} onChange={tabChange}>
        {itemList.map(item => (
          <Tabs.TabPane key={item.key}  name={item.name} title={`${item.label}`} >
            {activeTab === item.name && <SurverList type={item.key}></SurverList>}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  )
}

export default Survey